"use strict";

var AbstractApi = require("./AbstractApi");

var ApplePayApi = class extends AbstractApi {
	//Call made to SO API
	createApplePayPaymentSession(validationUrl) {
		return this.post({
			data: { "validationUrl": validationUrl },
			url: "/api/applepaypaymentsessions"
		});
	}
};

module.exports = new ApplePayApi();
